import { FCSelector } from '../../model/form-config.interface';
import {
  CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE,
  CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE_DETAILS,
} from './product-capture-field-selectors.consts';

export const ADDITIONAL_CREDIT_BUSINESS_CENTRE: FCSelector = {
  formControlNames: [CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE],
  options: [
    {
      id: true,
      effects: [
        {
          formControlNames: [
            CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE_DETAILS,
          ],
          readOnly: false,
        },
      ],
    },
    {
      id: false,
      effects: [
        {
          formControlNames: [
            CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE_DETAILS,
          ],
          readOnly: true,
        },
        {
          formControlNames: [
            CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE_DETAILS,
          ],
          selectValues: [null],
        },
      ],
    },
    {
      id: null,
      effects: [
        {
          formControlNames: [
            CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE_DETAILS,
          ],
          readOnly: true,
        },
        {
          formControlNames: [
            CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE_DETAILS,
          ],
          selectValues: [null],
        },
      ],
    },
  ],
};
